/**
 * Accessible name of a chip's remove button for the OPAL `MultipleSelect` (`removeChipLabel`):
 * "Remove {label}" in the user's language. Build it once in `setup`; it follows a locale change
 * because `t` runs when MultipleSelect renders the chip.
 */
export function buildRemoveChipLabel(t) {
    return (label) => t("common.removeItem", { label });
}
